import a,{memo as D,useState as p,useMemo as H,useEffect as K,Fragment as N}from"react";import{usePopper as q}from"react-popper";import{getDataSelector as m}from"@vfuk/core-base-props";import n,{css as t}from"styled-components";import{respondTo as G,applyFocus as J,elevation as Q,spacing as R,typography as h}from"@vfuk/core-mixins";const T=e=>({appearance:{primary:{backgroundColor:e.color.monochrome1.default,color:e.color.monochrome6.default},secondary:{backgroundColor:e.color.monochrome6.default,color:e.color.monochrome1.default}}}),c=typeof n=="object"&&"default"in n?n.default:n,z=c.span(()=>t`
    max-width: 288px;

    ${G.lg(t`
      max-width: 320px;
    `)}
  `),E=c.span(()=>t`
    ${J()}
  `),l=c.span(e=>{const o=T(e.theme);return t`
    &,
    &::before {
      position: absolute;
      width: 10px;
      height: 10px;
      box-shadow: ${e.theme.elevation.size}px 4px 4px -4px ${e.theme.elevation.color};
      z-index: ${e.zIndex};
    }

    &::before {
      content: '';
      background-color: ${o.appearance[e.appearance].backgroundColor};
      transform: rotate(45deg);
    }
  `}),k=c.div(e=>{const o=T(e.theme);return t`
    background-color: ${o.appearance[e.appearance].backgroundColor};
    color: ${o.appearance[e.appearance].color};
    border-radius: ${e.theme.border.radius[2]};
    ${Q(!0)}
    ${R("padding",3)}
    z-index: ${e.zIndex};

    &[data-popper-placement^='top'] > ${l} {
      bottom: -5px;
    }

    &[data-popper-placement^='bottom'] > ${l} {
      top: -5px;
    }

    ${e.size===1&&t`
      ${h.paragraph(1,!1)}
    `}

    ${e.size===2&&t`
      ${h.paragraph(2,!1)}
    `}
  `});var ae=Object.freeze({__proto__:null,TooltipArrow:l,TooltipBody:k,TooltipTrigger:E,TooltipWrapper:z}),U=Object.defineProperty,v=Object.getOwnPropertySymbols,V=Object.prototype.hasOwnProperty,X=Object.prototype.propertyIsEnumerable,w=(e,o,r)=>o in e?U(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,$=(e,o)=>{for(var r in o||(o={}))V.call(o,r)&&w(e,r,o[r]);if(v)for(var r of v(o))X.call(o,r)&&w(e,r,o[r]);return e};const Y=({appearance:e="primary",size:o=1,text:r,children:O,id:u,srText:I,zIndex:f=10,dataSelectorPrefix:i,dataAttributes:j})=>{const S="Tooltip",[C,b]=p(!1),[P,_]=p(null),[A,B]=p(null),[F,L]=p(null),M=H(()=>({name:"offset",options:{offset:({placement:d})=>d==="top"?[0,8]:[0,12]}}),[]),{styles:g,attributes:W}=q(P,A,{modifiers:[{name:"arrow",options:{element:F}},M,{name:"preventOverflow",options:{padding:{left:16,right:16,bottom:8}}}],placement:"top"}),y=()=>{b(!0)},s=()=>{b(!1)},x=d=>{d.key==="Escape"&&s()};return K(()=>(window.addEventListener("keydown",x),()=>{window.removeEventListener("keydown",x)}),[]),a.createElement(N,null,a.createElement(E,{ref:_,role:"button",onMouseOver:y,onFocus:y,onMouseLeave:s,onBlur:s,tabIndex:0,"aria-describedby":u,"aria-label":I,"data-selector":m(i,"trigger")},O),a.createElement(z,null,C&&a.createElement(k,$($({role:"tooltip",appearance:e,size:o,zIndex:f,id:u,ref:B,style:g.popper,"data-selector":m(i),"data-component-name":S},j),W.popper),r,a.createElement(l,{appearance:e,ref:L,style:g.arrow,zIndex:f,"data-selector":m(i,"arrow")}))))};var pe=D(Y);export{pe as Tooltip,ae as TooltipStyles,pe as default,T as tooltipTheme};
//# sourceMappingURL=index.js.map
